<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import Tile, { TileProps } from '../components/Tile.svelte';
    import { storeLanguage, lang_fr } from "../scripts/store";

    const tile01_fr: TileProps = {
        icon: "../assets/images/tile04.png",
        title: "Marque et visibilité",
        text: "Renforcez votre visibilité en tant qu'acteur reconnu sur les APIs. Associez votre marque au Collectif API Thinking et bénéficiez des multiples canaux de diffusion à disposition. Mettez votre marque en évidence sur le panorama de l'écosystème des APIs !"
    }

    const tile02_fr: TileProps = {
        icon: "../assets/images/tile05.png",
        title: "Rencontres et Business",
        text: "Développez des relations privilégiées avec 100 entreprises francophones à tous stades de développement : early stage, start-up, acteurs bancaires historiques et entreprises de tous secteurs."
    }

    const tile03_fr: TileProps = {
        icon: "../assets/images/tile06.png",
        title: "Veille et R&D",
        text: "Décelez les enjeux du secteur à venir, soyez actifs plutôt que passifs afin d'alimenter vos prises de décisions et de les accélérer au travers d'interviews d'entreprises."
    }

    const tile04_fr: TileProps = {
        icon: "../assets/images/tile07.png",
        title: "Restez à l'écoute",
        text: "Restez au plus près de l'écosystème au travers d'évènements (organisés par vous ou par nous), de publications (revues de presses, articles...), de rencontres..."
    }
    
    const tile01_en: TileProps = {
        icon: "../assets/images/tile04.png",
        title: "Brand and visibility",
        text: "Strengthen your visibility as a recognized player on APIs. Associate your brand with the API Thinking Collective and benefit from the multiple distribution channels available. Highlight your brand on the panorama of the API ecosystem!"
    }

    const tile02_en: TileProps = {
        icon: "../assets/images/tile05.png",
        title: "Dating and Business",
        text: "Develop privileged relationships with 100 French-speaking companies at all stages of development: early stage, start-ups, historical banking players and companies from all sectors."
    }

    const tile03_en: TileProps = {
        icon: "../assets/images/tile06.png",
        title: "Monitoring and R&D",
        text: "Detect the challenges of the sector to come, be active rather than passive in order to fuel your decision-making and accelerate it through company interviews."
    }

    const tile04_en: TileProps = {
        icon: "../assets/images/tile07.png",
        title: "Stay tuned",
        text: "Stay as close as possible to the ecosystem through events (organized by you or by us), publications (press reviews, articles...), meetings..."
    }

    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .devenirpartenaire {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 60px 32px;
            width: 100%;
        }
        &__contact {
            padding: 0 0 15px 15px;
            font-style: italic;
            font-size: 14px;
            color: $color_primary;
            align-self: flex-end;
        }
    }

    @include large {
        .devenirpartenaire {
            &__tiles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__tile {
                height: 100%;
                width: 40%;
            }
        }
    }

</style>

<div class="devenirpartenaire">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Devenir partenaire"/>
    {:else}
    <PageHeader props="To become partner"/>
    {/if}
    <div class="bloc devenirpartenaire__bloc">
        <div class="devenirpartenaire__title">
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Être partenaire du Collectif API Thinking, c’est être partenaire du <span class="font__h4">1er collectif français dédié aux APIs</span>. Il vous permettra de rayonner au plus près de votre écosystème, de communiquer à nos membres votre expertise, vos produits et de rencontrer de nouveaux partenaires, clients, prospects.
                {:else}
                Being a partner of the API Thinking Collective means being a partner of the <span class="font__h4">1st French collective dedicated to APIs</span>. It will allow you to radiate closer to your ecosystem, to communicate to our members your expertise, your products and to meet new partners, customers, prospects.
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Que vous soyez éditeurs de solution d’API Management, dans la sécurité des APIs, la gouvernance autour des APIs, sociétés de conseils, ESN, ce partenariat est fait pour vous !
                {:else}
                Whether you are an API Management solution publisher, in API security, governance around APIs, consulting companies, ESN, this partnership is made for you!
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Dans notre société post-COVID où le no-show des évènements atteint des sommets, il est temps de privilégier la qualité à la quantité, c’est donc une promesse de valeur qualitative que l’on vous promet.
                {:else}
                In our post-COVID society where the no-show of events reaches peaks, it is time to favor quality over quantity, it is therefore a promise of qualitative value that we promise you.
                {/if}
            </p>
            <p>
                {#if ($storeLanguage == $lang_fr)}
                Un partenariat s’établit sur une année civile et vous agrandit le champ des possibles :
                {:else}
                A partnership is established over a calendar year and expands the field of possibilities:
                {/if}
            </p>        
        </div>
        {#if ($storeLanguage == $lang_fr)}
        <div class="devenirpartenaire__tiles">
            <div class="devenirpartenaire__tile">
                <Tile props={tile01_fr}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile02_fr}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile03_fr}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile04_fr}/>
            </div>
        </div>
        {:else}
        <div class="devenirpartenaire__tiles">
            <div class="devenirpartenaire__tile">
                <Tile props={tile01_en}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile02_en}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile03_en}/>
            </div>
            <div class="devenirpartenaire__tile">
                <Tile props={tile04_en}/>
            </div>
        </div>
        {/if}
        <div class="devenirpartenaire__contact">
            {#if ($storeLanguage == $lang_fr)}
            N'hésitez pas à nous contacter à l'adresse indiquée dans le pied de page
            {:else}
            Do not hesitate to contact us at the address indicated in the footer
            {/if}
        </div>
    </div>
</div>
